// extracted by mini-css-extract-plugin
export default {"root":"classes_root__EbnNN","content":"classes_content__uGRCn"};